import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface CategoriesPopupProps {
  categories: string[];
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onClose: () => void;
}

const CategoriesPopup: React.FC<CategoriesPopupProps> = ({
  categories,
  anchorEl,
  isOpen,
  onClose,
}) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (anchorEl && isOpen) {
      const rect = anchorEl.getBoundingClientRect();

      // Calculate position - show above the anchor element
      setPosition({
        top: rect.top - 10, // Position above the anchor with a small gap
        left: rect.left - 150,
      });

      // Add event listener to close when clicking outside
      const handleClickOutside = (e: MouseEvent) => {
        if (anchorEl && !anchorEl.contains(e.target as Node)) {
          onClose();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [anchorEl, isOpen, onClose]);

  if (!isOpen || !anchorEl) return null;

  return createPortal(
    <div
      onMouseLeave={() => onClose()}
      className="fixed z-[1000] min-w-[300px] max-w-[300px] rounded-md border border-bordergray bg-white p-2 shadow-lg"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        maxHeight: '300px',
        overflow: 'auto',
      }}
    >
      <div className="flex flex-wrap gap-1">
        {categories.map((category, idx) => (
          <div
            key={idx}
            className="rounded-[20px] border-[1px] border-bordergray bg-white px-3 py-1"
          >
            {category}
          </div>
        ))}
      </div>
    </div>,
    document.body
  );
};

export default CategoriesPopup;
